var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMorningNotAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 22,
    viewBox: "0 0 29 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Morning-not-available"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4200",
    x: 0.5,
    y: 0.5,
    width: 27.3625,
    height: 20.78,
    rx: 5.5,
    fill: "white",
    stroke: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M",
    d: "M19.0618 5.9119V14.9469H17.5798V8.7589L14.8238 14.9469H13.7968L11.0278 8.7589V14.9469H9.54584V5.9119H11.1448L14.3168 12.9969L17.4758 5.9119H19.0618Z",
    fill: "#233849"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 66",
    x1: 26.2817,
    y1: 3.41311,
    x2: 4.28167,
    y2: 18.4131,
    stroke: "#B0AFAF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorningNotAvailable);
export default __webpack_public_path__ + "static/media/Morning-not-available.c127c49ff012eb185f81e9b05283ca4f.svg";
export { ForwardRef as ReactComponent };